export const hostSpecSchema = {
  id: "",
  licenseKey: "",
  hostNetworkSpec: {
    vmNics: [],
  },
};

export const genDataStoreSchema = (type) => {
  let dataStoreSchema = {};

  if (type === "vmfs") {
    dataStoreSchema = {
      vmfsDatastoreSpec: {
        fcSpec: [
          {
            datastoreName: "",
          },
        ],
      },
    };
  } else if (type === "nfs") {
    dataStoreSchema = {
      nfsDatastoreSpecs: [
        {
          nasVolume: {
            serverName: [""],
            path: "",
            readOnly: false,
          },
          datastoreName: "",
        },
      ],
    };
  } else if (type === "vvol") {
    dataStoreSchema = {
      vvolDatastoreSpecs: [
        {
          name: "",
          vasaProviderSpec: {
            vasaProviderId: "",
            storageContainerId: "",
            storageProtocolType: "",
            userId: "",
          },
        },
      ],
    };
  } else if (type === "vsan") {
    dataStoreSchema = {
      vsanDatastoreSpec: {
        failuresToTolerate: 1,
        licenseKey: "",
        datastoreName: "",
      },
    };
  }

  return dataStoreSchema;
};

export const genVdsPortGroupSchema = (vdsNumber, vsanChoosen) => {
  if (vsanChoosen) {
    return [
      {
        name: "",
        transportType: "MANAGEMENT",
      },
      {
        name: "",
        transportType: "VMOTION",
      },
      {
        name: "",
        transportType: "VSAN",
      },
    ];
  }

  return [
    {
      name: "",
      transportType: "MANAGEMENT",
    },
    {
      name: "",
      transportType: "VMOTION",
    },
  ];
};

export const mapVmNicToVds = (noOfVmNic, vdsNames) => {
  const noOfVmNicInEachVds = Math.ceil(noOfVmNic / vdsNames.length);
  const vmNics = [];

  for (let i = 0; i < vdsNames.length; i++) {
    if (vmNics.length === noOfVmNic) {
      break;
    }
    const vdsName = vdsNames[i];
    for (let j = 0; j < noOfVmNicInEachVds; j++) {
      if (vmNics.length === noOfVmNic) {
        break;
      }
      vmNics.push({
        id: `vmnic${vmNics.length}`,
        vdsName,
      });
    }
  }

  return vmNics;
};




export const evcModeOptions = ["intel-icelake", "intel-cascadelake", "intel-skylake", "intel-broadwell", "intel-haswell", "intel-ivybridge", "intel-sandybridge", "amd-zen2", "amd-zen", "amd-streamroller", "amd-piledriver"];
